import type { LeaveType } from '../types/leave';

/** All leave types in canonical display order. */
export const LEAVE_TYPES: LeaveType[] = [
  'annual',
  'half',
  'hourly1',
  'hourly2',
  'hourly3',
];

/**
 * Per-type leave-day cost. `annual` is the per-day base (range-multiplied).
 * Hourly costs follow an 8h-workday model: 1h=0.125, 2h=0.25, 3h=0.375, half(4h)=0.5.
 */
export const LEAVE_TYPE_DAYS: Record<LeaveType, number> = {
  annual: 1,
  half: 0.5,
  hourly1: 0.125,
  hourly2: 0.25,
  hourly3: 0.375,
};

/** Korean default labels (legacy LEAVE_TYPE_DESCRIPTIONS equivalents). */
export const LEAVE_TYPE_LABELS_KO: Record<LeaveType, string> = {
  annual: '연차',
  half: '반차',
  hourly1: '1시간 시차',
  hourly2: '2시간 시차',
  hourly3: '3시간 시차',
};

/** Only `annual` may span multiple days (carry an endDate > startDate). */
export const isRangeType = (type: LeaveType): boolean => type === 'annual';
